// On Scroll Animation

export default function onScroll() {
    const sections = document.querySelectorAll(".r-section, .r-hero");

    if (sections.length === 0) {
        console.warn("No sections found to observe.");
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("active");
                }
            });
        },
        {
            threshold: 0.24,
        }
    );

    sections.forEach((section) => observer.observe(section));
}
